import { render, staticRenderFns } from "./CashDeskTotals.vue?vue&type=template&id=3b75b463&scoped=true"
import script from "./CashDeskTotals.vue?vue&type=script&lang=js"
export * from "./CashDeskTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75b463",
  null
  
)

export default component.exports